module.exports = __webpack_public_path__ + "5f06680f64fb3bb86fea3d9ed329b858.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/meredicte/meredicte-6.jpg
// module id = 331
// module chunks = 1